import { combineEpics, Epic, ofType } from 'redux-observable';
import { map } from 'rxjs/operators';

import { Action } from '../../actions';
import {
    changeDealsColumnsOrderData,
    changeDealsColumnsVisibilityData,
    HANDLE_DEALS_COLUMNS_ORDER_CHANGE,
    HANDLE_DEALS_COLUMNS_VISIBILITY_CHANGE,
    HANDLE_DEALS_COLUMNS_WIDTH_UPDATE,
    HandleDealsColumnsOrderChangeAction,
    HandleDealsColumnsVisibilityChangeAction,
    HandleDealsColumnsWidthUpdateAction,
    updateDealsColumnsWidthData
} from '../../actions/deals';
import {
    getColumnSettingsWithUpdatedOrder,
    getColumnsVisibilitySettings,
    getColumnsWidthSettings
} from '../../service/ActionHelpers';
import { LocalStorage, StorageKeyType } from '../../service/Storage/Storage';
import { EpicDeps } from '../../service/StoreFactory';
import { deals } from '../../typings/common';
import { State } from '../../typings/state';

export const handleDealsColumnsWidthUpdateEpic: Epic<Action, Action, State, EpicDeps> = (action$, store$) => {
    return action$.pipe(
        ofType(HANDLE_DEALS_COLUMNS_WIDTH_UPDATE),
        map(
            (action: HandleDealsColumnsWidthUpdateAction): Action => {
                const { columnsSettings } = store$.value.deals;
                const settings = getColumnsWidthSettings(columnsSettings, action.key, action.width, deals, false);

                LocalStorage.setItem(StorageKeyType.dealsColumnsSettings, settings);

                return updateDealsColumnsWidthData(settings);
            }
        )
    );
};

export const handleDealsColumnsVisibilityChangeEpic: Epic<Action, Action, State, EpicDeps> = (action$, store$) => {
    return action$.pipe(
        ofType(HANDLE_DEALS_COLUMNS_VISIBILITY_CHANGE),
        map(
            (action: HandleDealsColumnsVisibilityChangeAction): Action => {
                const { columnsSettings } = store$.value.deals;
                const settings = getColumnsVisibilitySettings(columnsSettings, action.columns, deals);

                LocalStorage.setItem(StorageKeyType.dealsColumnsSettings, settings);

                return changeDealsColumnsVisibilityData(settings);
            }
        )
    );
};

export const handleDealsColumnsOrderChangeEpic: Epic<Action, Action, State, EpicDeps> = (action$, store$) => {
    return action$.pipe(
        ofType(HANDLE_DEALS_COLUMNS_ORDER_CHANGE),
        map(
            (action: HandleDealsColumnsOrderChangeAction): Action => {
                const { columnsSettings } = store$.value.deals;
                const settings = getColumnSettingsWithUpdatedOrder(columnsSettings, action.columnOrder, deals);

                LocalStorage.setItem(StorageKeyType.dealsColumnsSettings, settings);

                return changeDealsColumnsOrderData(settings[deals].columnOrder);
            }
        )
    );
};

export const dealsHelpersEpic = combineEpics(
    handleDealsColumnsWidthUpdateEpic,
    handleDealsColumnsVisibilityChangeEpic,
    handleDealsColumnsOrderChangeEpic
);
